<script>
  export default {
    name: "DpListItem",
    props: {
      action: {type: Function, default: () => {}},
      quickActions: {type: Boolean, default: false},
      pointer: {type: Boolean, default: false},
      hoverAnimation: {type: Boolean, default: false},
      marked: {type: String, default: ''}
    },
    computed: {
      classesMarked() {
        return {
          'marked__success': this.marked === 'success',
          'marked__warning': this.marked === 'warning',
          'marked__error': this.marked === 'error' || this.marked === 'danger'
        }
      }
    }
  }
</script>

<template>
  <div class="dp-list-item" :class="{'hover-animation': hoverAnimation, ...classesMarked}">
    <div @click="action()">
      <div class="dp-list-item__headline" :class="{'pointer': pointer}">
        <slot name="headline"></slot>
      </div>

      <div class="dp-list-item__content" :class="{'pointer': pointer}">
        <slot></slot>
      </div>
    </div>

    <div v-if="quickActions" class="dp-list-item__quick-actions background-gradient-1">
      <slot name="quick-actions"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .dp-list-item {
    margin: 1rem 0;
    border: 2px solid var(--use-theme__ui-gradient-2);
    border-radius: 8px;

    &.marked__success {
      border-color: var(--use-theme__event__success__border-color);
    }
    &.marked__warning {
      border-color: var(--use-theme__event__warning__border-color);
    }
    &.marked__error {
      border-color: var(--use-theme__event__error__border-color);
    }

    &.hover-animation {
      transition: 0.3s;
      transition-duration: 0.3s;
      transition-property: all;
      transition-timing-function: ease-out;
      transition-delay: 0.11s;
      &:hover {
        box-shadow: 0 3px 12px 0 rgba(0,0,0,.10);
        transform: translateY(-0.5px);
      }
    }

    .pointer {
      cursor: pointer;
    }

    .dp-list-item__headline {
      padding: 1rem 1.3rem .5rem 1.3rem;
      font-size: 1.5em;
      letter-spacing: -0.5px;
    }

    .dp-list-item__content {
      font-size: 1em;
      padding: .5rem 1.3rem 1rem 1.3rem;
    }

    .dp-list-item__quick-actions {
      padding: 0;
      border-radius: 0 0 8px 8px;
    }
  }

</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
